import { AdminApiProxiedService, AdminApiService } from '../services';
import type { CampaignSecretSetRequest } from '../services';
import type { CampaignCreate, CampaignUpdate } from '../services';

export type GetCampaignsFilters = { search?: string; status?: string };
export type GetCampaignMonitoringFilters = {
  search?: string;
  campaignId?: string;
  latestContactStateEnum?: string;

  updatedFrom?: string | null;
  updatedTo?: string | null;
};
export type CampaignCreatePayload = CampaignCreate;
export type CampaignUpdatePayload = CampaignUpdate;

export type TransferCampaignToOrganizationPayload = {
  campaignId: string;
  organizationId: string;
};

export const getCampaigns = (
  filters: GetCampaignsFilters,
  page: ApiPaginationType
) => {
  return AdminApiService.getCampaignsApiAdminCampaignsGet(
    filters.status,
    page.limit,
    page.offset
  );
};

export const getMonitoring = ({
  filters,
  sort,
  page,
}: GetMonitoringPayload) => {
  return AdminApiService.getCampaignMonitoringApiAdminCampaignMonitoringGet(
    filters.campaignId,
    filters.search,
    filters.latestContactStateEnum,
    sort,
    filters.updatedFrom,
    filters.updatedTo,
    page.limit,
    page.offset
  );
};

export const addCampaign = (payload: CampaignCreatePayload) => {
  return AdminApiService.createCampaignApiAdminCampaignsPost(payload);
};
export const updateCampaign = (id: string, payload: CampaignUpdatePayload) => {
  return AdminApiService.updateCampaignApiAdminCampaignsCampaignIdPatch(
    id,
    payload
  );
};
export const deleteCampaign = (id: string) => {
  return AdminApiService.deleteCampaignApiAdminCampaignsCampaignIdDelete(id);
};

export const getCampaignMonitoring = (
  id: string,
  { filters, page, sort }: GetCampaignMonitoringPayload
) => {
  return AdminApiService.getCampaignMonitoringDynamicApiAdminCampaignMonitoringDynamicGet(
    id,
    filters?.search,
    filters?.latestContactStateEnum,
    sort,
    filters?.updatedFrom,
    filters?.updatedTo,
    page?.limit,
    page?.offset
  );
};

export const copyCampaign = async (campaignId: string) => {
  return AdminApiProxiedService.copyCampaignAdminCampaignsCampaignIdCopyPost(
    campaignId
  );
};

export const transferCampaignToOrganization = async ({
  campaignId,
  organizationId,
}: TransferCampaignToOrganizationPayload) => {
  return AdminApiProxiedService.transferCampaignAdminCampaignsCampaignIdTransferPost(
    campaignId,
    { organization_id: organizationId }
  );
};

export const exportCampaign = async (campaignId: string) => {
  return AdminApiProxiedService.exportCampaignAdminCampaignsCampaignIdExportGet(
    campaignId
  );
};

export const importCampaign = async (payload: any) => {
  return AdminApiProxiedService.importCampaignAdminCampaignsImportPost(payload);
};

export const KEY_NAME_OPENROUTER = 'openrouter';

export const getCampaignSecrets = (campaignId: string) => {
  return AdminApiService.listCampaignSecretsApiAdminCampaignsCampaignIdSecretsGet(
    campaignId
  );
};

export const getCampaignSecret = (campaignId: string, keyName: string) => {
  return AdminApiService.getCampaignSecretApiAdminCampaignsCampaignIdSecretsKeyNameGet(
    campaignId,
    keyName
  );
};

export const setCampaignSecret = (
  campaignId: string,
  keyName: string,
  payload: CampaignSecretSetRequest
) => {
  return AdminApiService.setCampaignSecretApiAdminCampaignsCampaignIdSecretsKeyNamePut(
    campaignId,
    keyName,
    payload
  );
};

export const deleteCampaignSecret = (campaignId: string, keyName: string) => {
  return AdminApiService.deleteCampaignSecretApiAdminCampaignsCampaignIdSecretsKeyNameDelete(
    campaignId,
    keyName
  );
};

export type GetMonitoringPayload = {
  sort?: string | null;
  page: ApiPaginationType;
  filters: GetCampaignMonitoringFilters;
};
export type GetCampaignMonitoringPayload = {
  sort?: string | null;
  page: ApiPaginationType;
  filters?: GetCampaignMonitoringFilters;
};
export type { CampaignResponse as CampaignType } from '../services';
export type { DynamicMonitoringResponse as CampaignMonitoringResponse } from '../services';
export type { CampaignMonitoringResponse as CampaignMonitoringItemType } from '../services';
